import {
  Employment,
  EmploymentActionType,
} from 'src/components/Loan/Application/Sections/EmploymentInfo/Inputs/Employments/store/types';

type EmploymentStore = Employment[];

const defaultState: EmploymentStore = [];

const reducer = (
  state: EmploymentStore = defaultState,
  { type, data }: { type: EmploymentActionType; data: any },
): EmploymentStore => {
  switch (type) {
    // @ts-ignore
    case 'clear_loan_data':
      return defaultState;
    case EmploymentActionType.SET: {
      const items = [...state];
      for (const item of data) {
        const matchIndex = state.findIndex((x) => x.id === item.id);
        if (matchIndex > -1) {
          items.splice(matchIndex, 1, {
            ...items[matchIndex],
            ...item,
          });
        } else {
          items.push(item);
        }
      }
      return items;
    }
    case EmploymentActionType.UPDATE: {
      const matchIndex = state.findIndex((x) => x.id === data.id);
      const items = [...state];

      items.splice(matchIndex, 1, {
        ...items[matchIndex],
        ...data,
      });
      return items;
    }
    case EmploymentActionType.ADD: {
      const items = [...state, data];
      return items;
    }
    case EmploymentActionType.DELETE: {
      const matchIndex = state.findIndex((x) => x.id === data);
      const items = [...state];
      items.splice(matchIndex, 1);
      return items;
    }
    default:
      return state;
  }
};

export default reducer;
